import { TextField, TextFieldProps } from '@mui/material';
import { getGridNumericOperators, GridFilterInputValueProps } from '@mui/x-data-grid';
import { GridCellParams, GridFilterItem, GridFilterOperator } from '@mui/x-data-grid-pro';
import * as React from 'react';

const SUBMIT_FILTER_STROKE_TIME = 500;
const CommaSeparatedPaste: React.FunctionComponent<GridFilterInputValueProps> = (props) => {
    const { item, applyValue, focusElementRef = undefined } = props;

    const filterTimeout = React.useRef<unknown>();
    const [filterValueState, setFilterValueState] = React.useState(item.value as string);

    const updateFilterValue = (val: string): void => {
        clearTimeout(filterTimeout.current as number);
        setFilterValueState(val);

        filterTimeout.current = setTimeout(() => {
            if ('' === val) {
                applyValue({ ...item, value: undefined });

                return;
            }
            // convert out CSV into an array to be used by getApplyFilterFn
            const valArray = val.split(',');
            // now remove any empty strings and map everything to numbers
            const normalizedVals = valArray.filter((filter) => '' !== filter).map(Number);
            const updatedItem = { ...item, value: normalizedVals };
            applyValue(updatedItem);
        }, SUBMIT_FILTER_STROKE_TIME);
    };

    const handleFilterChange: TextFieldProps['onChange'] = (event) => {
        const newVal = event.target.value;
        updateFilterValue(newVal);
    };

    return (
        <TextField
            name='csv-input'
            placeholder='Filter value'
            label='CSV-Input'
            variant='standard'
            value={filterValueState}
            onChange={handleFilterChange}
            type='string'
            inputRef={focusElementRef}
            InputLabelProps={{
                shrink: true,
            }}
        />
    );
};

export const commaSepPasteFilter: GridFilterOperator[] = [
    {
        label: 'CSV',
        value: 'CSV',
        getApplyFilterFn: (filterItem: GridFilterItem): ((params: GridCellParams) => boolean) | null => {
            if (!filterItem.field || !filterItem.value || !filterItem.operator) {
                // custom filter operator needs explicit null value.
                // eslint-disable-next-line no-null/no-null
                return null;
            }

            return (params: GridCellParams): boolean => {
                return (filterItem.value as number[]).includes(params.value as number);
            };
        },
        InputComponent: CommaSeparatedPaste,
        InputComponentProps: { value: 'string' },
    },
    ...getGridNumericOperators(),
];
